<template>
  <svg
    id="close"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g>
      <path
        id="Path_8169"
        data-name="Path 8169"
        d="M8,8l6,6m0-6L8,14"
        transform="translate(-2 -2)"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8168" data-name="Path 8168" d="M0,0H18V18H0Z" fill="none" />
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
